import { MaterialShape } from "@enums/materialShape.enum";
import { Guid } from "guid-typescript";

export interface PurchaseLogLineItem {
	cost: number;
	height: number;
	length: number;
	lineCost: number;
	lineDescription: string;
	lineNumber: number;
	lookupId: Guid;
	materialShape: MaterialShape;
	partId?: number;
	quantity: number;
	quantityAllocated: number;
	received: number;
	thickness: number;
	weight: number;
	width: number;
}

export class PurchaseLogLineItem implements PurchaseLogLineItem {
	cost = 0;
	length = 0;
	lineCost = 0;
	lineDescription = "";
	lineNumber = 0;
	materialShape = MaterialShape.Sheet;
	quantity = 0;
	quantityAllocated = 0;
	received = 0;
	thickness = 0;
	width = 0;

	constructor(data?: Partial<PurchaseLogLineItem>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}